import {
    DISMISS_ALERT,
    DISMISS_ALERT_FAIL,
    DISMISS_ALERT_SUCCESS,
    RESET_DISMISS_ALERT
} from './actionTypes';

const initialState = {
    alertToDismiss: {},
    alertDismissed: {},
    error: null,
    loading: false,
    loaded: false
};

export function dismissAlertReducer(state = initialState, action) {
    switch (action.type) {
        case DISMISS_ALERT: {
            return {
                ...initialState,
                alertToDismiss: action.payload,
                loading: true
            };
        }
        case DISMISS_ALERT_SUCCESS: {
            return {
                ...initialState,
                alertDismissed: action.payload,
                loaded: true
            };
        }
        case DISMISS_ALERT_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        case RESET_DISMISS_ALERT: {
            return initialState;
        }
        default:
            return state;
    }
}
